// ErrorModal.jsx
import ErrorStore from "./ErrorStore";

function ErrorModal() {
  const { isOpen, message, closeError } = ErrorStore();

  if (!isOpen) return null;

  return (

        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="w-full max-w-md mx-4 overflow-hidden rounded-2xl bg-white shadow-2xl animate-in fade-in zoom-in duration-200">
        
        <div className="flex items-center gap-3 border-b px-6 py-4">
          <div className="text-center">
            <h2 className="text-lg font-semibold text-gray-900 ">
              Error
            </h2>
          </div>
        </div>

        <div className="px-6 py-5">
            <p className="text-sm text-black-700 break-words">
              {message}
            </p>
        </div>

        <div className="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4">
          <button
            onClick={closeError}
            className="btn btn-primary"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  
  );
}

export default ErrorModal;